module.exports = __webpack_public_path__ + "static/media/avslutte.8ddee088.m4a";